import { Injectable } from '@angular/core';
import { SelectOption, CascaderOption, InputNumber } from '../model/common-type';

// 控件列表
export class Filter {
  type: FilterListType;
  label: string;  // 文本
  name: string;  // 字段名称
  placeholder?: string; // 输入框提示文案
  value?: string | boolean | number | Array<string | Date> | null = null;  // 值 不传默认为null
  // 组件内部成员
  show?: boolean;
  selectOption?: SelectOption;  // 控件为Select时，选项列表
  inputNumber?: InputNumber = new InputNumber(); // number组件的min、max、step
  onSearchEvent?: Function;  // select选择器搜索事件 可用于更新备选集合
  onChangeEvent?: Function;   // 控件的值改变事件 可用于控件间联动
  onOpenChangeEvent?: Function; // select下拉展开/收起；展开时组件先清空 selectList 再回调，可用于按需请求
  onBlurEvent?: Function;     // 控件失去焦点事件
  hdDisabledDate?: Function; // date-picker组件不可选择的日期
  showTime?: boolean = false; // 日期选择器是否包含时间
  require?: boolean = false; // 是否必填
  /**
   * 是否允许清空当前筛选项（Input 清空按钮、Select/Date/Cascader 等清空图标）。
   * 不传默认 true；Select 未配此项时仍可回退到 selectOption.hdAllowClear
   */
  hdAllowClear?: boolean;
  cascaderOption?: CascaderOption; // 级联选择器配置
  onChangeEventDebounceTime?: number; // change事件防抖
  onSearchEventEventDebounceTime?: number; // search事件防抖
  onOpenChangeEventDebounceTime?: number; // 下拉展开事件防抖，未配置或为0时同步触发（不防抖）
}


// 控件类型
export enum FilterListType {
  Input,  // 输入框
  Select,  // 单项选择器
  Date,  // 单个日期选择
  DateRange,  // 日期范围选择
  MultipleSelect, // 多选
  Cascader, // 级联选择
  Month, // 月份选择
  InputNumber // 数字输入
}


@Injectable({
  providedIn: 'root'
})
export class HdFilterService {

  constructor() {
  }

}
